export const BOOST_TYPE_OPTIONS = [
    { name: 'Short Answer', value: 'text' },
    { name: 'Paragraph', value: 'textarea' },
    { name: 'Checkboxes', value: 'checkbox' },
    { name: 'Dropdown', value: 'dropdown' },
    { name: 'Radio', value: 'radio' },
    { name: 'Date', value: 'date' },
    { name: 'Time', value: 'time' },
    { name: 'File Upload', value: 'file' }
]



